<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tit1"><a id="page_iii"></a>Double Agent</h1>
<h1 class="tit2">Balloon</h1>
<p class="stit">Dickie Metcalfe’s Espionage</p>
<p class="stit">Career for MI5 and the Nazis</p>
<p class="author">DAVID TREMAIN</p>
<div class="img_container">
<img alt="Images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?52aaf4d7